export const FAQ = [
  {
    id: 1,
    question: "What is Ecomoto?",
    answer:
      "Ecomoto is a platform that allows you to rent electric vehicles in the United States. ",
  },
  {
    id: 2,
    question: "Can i book for a vehicle online?",
    answer:
      "Yes, you can book for a vehicle online. You can book for a vehicle up to 15 minutes before the start of the rental. You can also book for a vehicle directly on the street.",
  },
  {
    id: 3,
    question: "Does Ecomoto provides secure vehicles?",
    answer:
      "Yes, Ecomoto provides secure vehicles. All our vehicles are insured. In case of accident, the insurance will cover the damages.",
  },
  {
    id: 4,
    question: "What is form endpoint?",
    answer:
      "The form endpoint is the URL where the user can submit the form. The form endpoint is defined in the Ecomoto settings.",
  },
  {
    id: 5,
    question: "What happens if I lost the vehicle key?",
    answer:
      "If you lost the vehicle key, you will have to pay a fee of 50€. If you lost the vehicle key, you will have to pay a fee of 50€.",
  },
  {
    id: 6,
    question: "Does Ecomoto support blockchain?",
    answer:
      "Yes, Ecomoto supports blockchain. Ecomoto is a blockchain-based platform. Ecomoto is a blockchain-based platform.",
  },
];
